import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../log/log.service';

@Pipe({
  name: 'masterBill'
})
export class MasterBillPipe implements PipeTransform {

  constructor(private translateService: TranslateService,
              private logService: LogService) {
  }

  transform(value: boolean, args?: any): any {

    // Pipes need to handle nulls/undefined
    if (!value) {
      value = false;
    }

    let returnValue = '';

    switch (value) {
      case false:
        returnValue = this.translateService.instant('EVENTS.MASTER_BILL_NOT_PAID');
        break;
      case true:
        returnValue = this.translateService.instant('EVENTS.MASTER_BILL_PAID');
        break;
      default:
        this.logService.info(this.translateService.instant('EVENTS.MASTER_BILL_UNKNOWN', { key: value }));
    }

    return returnValue;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pipes/master-bill.pipe.ts